import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboardUI from '../components/AdminDashboardUI';

export default function AdminDashboard({ onLogout, onSwitchProfile }) {
  const navigate = useNavigate();

  const handleBackToMenu = () => {
    navigate('/inicio');
  };

  return (
    <AdminDashboardUI 
      onLogout={onLogout} 
      onSwitchProfile={onSwitchProfile} 
      onBackToMenu={handleBackToMenu}
    />
  );
}
